<p>{{ config?.text }}</p>
